import { Dates } from '@components/Dates';
import Block from '@components/Layout/Block';

import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import { Header, HistoryTable, HistoryTableMobile, Label, SmallText, Text } from './styles';

export interface Event {
  date: string;
  price: string;
  status: string;
  description: string;
  source: string;
}

export interface PropertyHistoryProps {
  eventHistory: Event[];
  locale?: string;
}

const PropertyHistory = ({ eventHistory, locale }: PropertyHistoryProps): ReactNode => {
  const t = useTranslations();
  return (
    <Block narrow>
      <Header>{t('Property History')}</Header>
      <HistoryTable>
        <thead>
          <tr>
            <th>{t('Date')}</th>
            <th>{t('Price')}</th>
            <th>{t('Event')}</th>
          </tr>
        </thead>
        {eventHistory && (
          <tbody>
            {eventHistory.map(function (event) {
              return (
                <tr>
                  <td>
                    <Text>
                      <Dates startDate={event.date} locale={locale} variant={true} />
                    </Text>
                  </td>
                  <td>
                    <Text>{event.price}</Text>
                  </td>
                  <td>
                    {event.status && <Text>{event.status}</Text>}
                    {event.description && <Text>{event.description}</Text>}
                    {event.source && (
                      <SmallText>
                        <span>{t('Source')}:</span> {event.source}
                      </SmallText>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        )}
      </HistoryTable>

      <HistoryTableMobile>
        {eventHistory &&
          eventHistory.map(function (event) {
            return (
              <tr>
                <td>
                  <Label>{t('Date')}</Label>
                  <Text>{event.date}</Text>

                  <Label $event={true}>{t('Event')}</Label>
                  {event.status && <Text>{event.status}</Text>}
                  {event.description && <Text>{event.description}</Text>}
                  {event.source && (
                    <SmallText>
                      <span>{t('Source')}:</span> {event.source}
                    </SmallText>
                  )}
                </td>
                <td>
                  <Label>{t('Price')}</Label>
                  <Text>{event.price}</Text>
                </td>
              </tr>
            );
          })}
      </HistoryTableMobile>
    </Block>
  );
};

export default PropertyHistory;
